/*
 * Shows more eTrusted (Trusted Shops) reviews than the widget's default three.
 * There is no reviews-per-page setting, but etrusted-review-list paging lives in
 * two writable fields we set and its own code reads:
 *
 *   pageTotal  — render() slices the list to it
 *   PAGE_SIZE  — the step loadMore() adds, and the value showLess()/update() reset to
 */
class TrustedShopReviews extends HTMLElement {
	connectedCallback() {
		const POLL_INTERVAL = 100;
		const MAX_ATTEMPTS = 150;

		this.target = parseInt(this.dataset.initialReviews, 10) || 0;
		if (!this.target) return;
		let attempts = 0;

		// No ready event to listen for, and attaching a shadow root fires no
		// mutations, so poll until the widget has rendered.
		this.poll = setInterval(() => {
			const list = this.reviewList;

			if (list) {
				clearInterval(this.poll);
				this.expand(list);
			} else if (++attempts >= MAX_ATTEMPTS) {
				clearInterval(this.poll);
			}
		}, POLL_INTERVAL);
	}

	disconnectedCallback() {
		clearInterval(this.poll);
	}

	async expand(list) {
		const reviews = list.data && list.data.reviews;
		if (!Array.isArray(reviews) || !list.pageTotal) return;

		// Drop star-only ratings at the source so paging counts what the visitor
		// sees, and still does after a filter or sort re-reads data.reviews.
		list.data.reviews = reviews.filter((review) => review.comment?.trim());
		list.PAGE_SIZE = this.target;
		list.pageTotal = this.target;

		// eTrusted's own method: redraws from the start, sliced to pageTotal.
		await list.render(list.data.reviews);
	}

	// theme.liquid opens every etrusted-* shadow root so we can reach inside.
	get reviewList() {
		const widget = this.querySelector('etrusted-widget');
		const listWidget = widget?.shadowRoot?.querySelector('etrusted-product-review-list-widget');

		return listWidget?.shadowRoot?.querySelector('etrusted-review-list');
	}
}

if (!customElements.get('trusted-shop-reviews')) {
	customElements.define('trusted-shop-reviews', TrustedShopReviews);
}
